import React from "react";
import ExcelJS from "exceljs";
import { parseCustomDate } from "../dashboard/ExcelVettingReport";
import moment from "moment";

const ExcelEmergentReport = ({ data }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data)) {
            console.error("Data is not an array:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Define columns
        worksheet.columns = [
            { header: 'S.No', key: 'serial_no', width: 10 },
            { header: 'File No', key: 'file_no', width: 20 },
            { header: 'File Emergent Initiate Type', key: 'emergent_type', width: 20 },
            { header: 'Law Hands Branch Name', key: 'lh_branch', width: 20 },
            { header: 'Bank Name', key: 'bank_name', width: 25 },
            { header: 'Product', key: 'product_name', width: 15 },
            { header: 'Grade', key: 'emergent_file_grade', width: 15 },
            { header: 'Bank Branch Name', key: 'branch_name', width: 25 },
            { header: 'Borrower Name', key: 'borrower_name', width: 25 },
            { header: 'Property Owner name', key: 'property_owner', width: 25 },
            { header: 'App Id', key: 'app_id', width: 25 },
            { header: 'Login Date', key: 'login_dt', width: 20 },
            { header: 'File Arrived Date & Time', key: 'arrived_dt', width: 20 },
            { header: 'File Emergent Initiate Date & Time', key: 'emergent_init_dt', width: 20 },
            { header: 'Emergent Initiate By', key: 'emergent_by', width: 20 },
            { header: 'Initiated Officer Designation', key: 'emergent_initiated_by_designation', width: 30 },
            { header: 'Emergent File Received by', key: 'emergent_received_by', width: 30 },
            { header: 'File Picked By', key: 'picked_by', width: 15 },
            { header: 'File Picked Date & Time', key: 'picked_dt', width: 20 },
            { header: 'File Completed Date & Time', key: 'completed_dt', width: 25 },
            { header: 'File Initial Status', key: 'initial_status', width: 15 },
            { header: 'File Completed Status', key: 'completed_status', width: 20 },
            { header: 'No.of Times Query Raised', key: 'no_of_time_query_raised', width: 20 },
            { header: 'Total Count of Queries ', key: 'total_query_count', width: 20 },
            { header: 'File Waiting Time', key: 'waiting_time', width: 15 },
            { header: 'File Working Time', key: 'working_time', width: 15 },
            { header: 'Total Time', key: 'total_time', width: 15 },
            { header: 'Total No of LOD', key: 'no_of_lod', width: 15 },
            { header: 'Total Related Lod', key: 'no_of_lod_related', width: 15 },
            { header: 'Total Not Related', key: 'no_of_lod_not_related', width: 15 },
            { header: 'Received LOD Count', key: 'lod_count', width: 15 },
            { header: 'Received LOD Count Related', key: 'active_lod', width: 15 },
            { header: 'Received LOD Count Not Related', key: 'inactive_lod', width: 15 },
            { header: 'Received Queries', key: 'received_queries', width: 50 },
        ];

        // Style header row
        worksheet.getRow(1).eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
            cell.font = { bold: true, size: 14 };
        });

        const processedData = data.map((item) => {
            // Parse dates
            const arrived = item.arrived_dt ? moment(item.arrived_dt, "DD-MM-YYYY HH:mm:ss") : null;
            const picked = item.picked_dt ? moment(item.picked_dt, "DD-MM-YYYY HH:mm:ss") : null;
            const completed = item.completed_dt ? moment(item.completed_dt, "DD-MM-YYYY HH:mm:ss") : null;

            // Waiting & Working time (ms)
            const waiting_diff =
                arrived && picked && arrived.isValid() && picked.isValid()
                    ? picked.diff(arrived)
                    : 0;

            const working_diff =
                picked && completed && picked.isValid() && completed.isValid()
                    ? completed.diff(picked)
                    : 0;

            // 🔥 TOTAL TIME = waiting + working
            const total_time_ms = waiting_diff + working_diff;

            const first_set_doc_list = item.received_queries
                .map(
                    (doc, docIndex) => `${docIndex + 1}. ${doc.mergedValue}`
                )
                .join("\n");

            return {
                ...item,

                // Convert to fraction of a day
                waiting_time: waiting_diff ? waiting_diff / (24 * 60 * 60 * 1000) : null,
                working_time: working_diff ? working_diff / (24 * 60 * 60 * 1000) : null,
                total_time: total_time_ms ? total_time_ms / (24 * 60 * 60 * 1000) : null,

                no_of_time_query_raised: parseInt(item.no_of_time_query_raised, 10) || 0,
                total_query_count: parseInt(item.total_query_count, 10) || 0,
                no_of_lod: parseInt(item.no_of_lod, 10) || 0,
                no_of_lod_related: parseInt(item.no_of_lod_related, 10) || 0,
                no_of_lod_not_related: parseInt(item.no_of_lod_not_related, 10) || 0,
                lod_count: parseInt(item.lod_count, 10) || 0,
                active_lod: parseInt(item.active_lod, 10) || 0,
                inactive_lod: parseInt(item.inactive_lod, 10) || 0,

                login_dt: item.login_dt ? parseCustomDate(item.login_dt) : "",
                arrived_dt: item.arrived_dt ? parseCustomDate(item.arrived_dt) : "",
                emergent_init_dt: item.emergent_init_dt ? parseCustomDate(item.emergent_init_dt) : "",
                picked_dt: item.picked_dt ? parseCustomDate(item.picked_dt) : "",
                completed_dt: item.completed_dt ? parseCustomDate(item.completed_dt) : "",
                received_queries: first_set_doc_list,
            };
        });

        // Add data rows to Excel
        processedData.forEach((item) => {
            const row = worksheet.addRow(item);

            row.eachCell((cell, colNumber) => {
                if ([ 25, 26, 27].includes(colNumber)) { // Waiting and Working Time columns
                    if (cell.value !== null) {
                        cell.numFmt = '[h]:mm:ss'; // Excel format for time
                    } else {
                        cell.value = ''; // Clear cell if no value
                    }
                } else if ([23, 24, 28, 29, 30, 31, 32, 33].includes(colNumber)) { // No of LOD
                    cell.numFmt = '0';
                } else if ([12, 13, 14, 19, 20].includes(colNumber)) {
                    cell.numFmt = 'dd-mm-yyyy hh:mm:ss'; // For date & time format
                }

                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            });
        });

        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
        // Generate Excel file buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Emergent Report ${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <>
            <button className="excel-download-btn" onClick={exportExcelFile}>
                Download as Excel
            </button>
        </>
    );
};

export default ExcelEmergentReport;
